import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EstablishmentService } from '../../../services/establishment/establishment.service';
import { ToastService } from '../../../services/toast/toast.service';
import { LoaderComponent } from '../../../atoms/loader/loader.component';

// add or edit a room. data.room = row when editing (null when adding);
// data.propertyId = the property the new room belongs to (add mode). self-saving.
@Component({
  selector: 'app-room-form-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    LoaderComponent,
  ],
  templateUrl: './room-form-dialog.component.html',
  styleUrls: ['./room-form-dialog.component.scss', '../../../../common-style/ac-dialog.scss'],
})
export class RoomFormDialogComponent implements OnInit {
  form: FormGroup;
  isEdit: boolean = false;
  isLoading: boolean = false;

  roomTypes = ['HALL', 'ROOM', 'DORMITORY'];
  genders = ['MALE', 'FEMALE', 'BOTH'];

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<RoomFormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { room: any | null; propertyId: number | null },
    private establishmentService: EstablishmentService,
    private toastService: ToastService
  ) {
    this.form = this.fb.group({
      roomNumber: ['', Validators.required],
      floor: [''],
      capacity: [null, [Validators.required, Validators.min(1)]],
      roomType: ['ROOM', Validators.required],
      gender: ['BOTH', Validators.required],
    });
  }

  ngOnInit(): void {
    if (this.data?.room) {
      this.isEdit = true;
      const r = this.data.room;
      this.form.patchValue({
        roomNumber: r.roomNumber || '',
        floor: r.floor || '',
        capacity: r.capacity ?? null,
        roomType: r.roomType || 'ROOM',
        gender: r.gender || 'BOTH',
      });
    }
  }

  submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.toastService.error('Room number, capacity, type and gender are required.');
      return;
    }
    this.isLoading = true;
    const payload: any = { ...this.form.value };
    let request$;
    if (this.isEdit) {
      request$ = this.establishmentService.updateRoom(this.data.room.roomId, payload);
    } else {
      payload.propertyId = this.data.propertyId;
      request$ = this.establishmentService.addRoom(payload);
    }

    request$.subscribe({
      next: (res: any) => {
        this.toastService.success(res?.message || 'Room saved.');
        this.isLoading = false;
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to save room.');
      },
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
